// component
import { useParams } from 'react-router-dom';
import Iconify from '../../components/Iconify';
import LucideIcon from '../../components/LucideIcon';

// ----------------------------------------------------------------------

const getIcon = (name) => <LucideIcon name={name} />;



const navConfig = [
  /* {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon('LayoutDashboard'),
  },
  {
    title: 'Configuration',
    path: '',
    icon: getIcon(''),
  },
  {
    title: 'Donnée événement',
    path: '/dashboard/information',
    icon: getIcon('Settings'),
  },
  {
    title: 'Billet & Mise en vente',
    path: '/dashboard/billets',
    icon: getIcon('Ticket'),
  }, */
  /* {
    title: 'user',
    path: '/dashboard/user',
    icon: getIcon('eva:people-fill'),
  }, */
  /* {
    title: 'Seances',
    path: '/dashboard/datelist',
    icon: getIcon('CalendarDays'),
  },
  {
    title: 'Communication',
    path: '',
    icon: getIcon(''),
  },
  {
    title: 'Code de promotions',
    path: '/dashboard/code_promo',
    icon: getIcon('BadgePercent'),
  },
  {
    title: 'Affiliation',
    path: '/dashboard/affiliate',
    icon: getIcon('Share2'),
  },
  
  {
    title: 'Autre canal de vente',
    path: '',
    icon: getIcon(''),
  },
  
  {
    title: 'Widget',
    path: '/dashboard/site_personnel',
    icon: getIcon('AppWindow'),
  },
  {
    title: 'Participants',
    path: '',
    icon: getIcon(''),
  },
  {
    title: 'Gérer les participants',
    path: '/dashboard/participants',
    icon: getIcon('UsersRound'),
  },
  {
    title: 'Ajouter des participants',
    path: '/dashboard/ajout_participant',
    icon: getIcon('UserPlus'),
  },
  
  {
    title: 'Contrôle d\'acces',
    path: '',
    icon: getIcon(''),
  }, */
  /* {
    title: 'Liste de contrôle',
    path: '/404',
    icon: getIcon('fluent:text-bullet-list-square-person-20-filled'),
  }, */
  /* {
    title: 'Opérateurs',
    path: '/dashboard/verification',
    icon: getIcon('ScanQrCode'),
  },
  {
    title: 'Statistiques',
    path: '',
    icon: getIcon(''),
  },
  {
    title: 'Participation',
    path: '/dashboard/statistique',
    icon: getIcon('ChartLine'),
  }, */
  /**  */
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: 'LayoutDashboard',
  },
  {
    title: 'Configuration event',
    path: '/dashboard/information',
    icon: 'Settings',
  },
  {
    title: 'Billet & Mise en vente',
    path: '/dashboard/billets',
    icon: 'Ticket',
  },
  {
    title: 'Seances',
    path: '/dashboard/datelist',
    icon: 'CalendarDays',
  },
  {
    title: 'Communication',
    icon: 'Megaphone',
    children: [
      {
        title: 'Code de promotions',
        path: '/dashboard/code_promo',
      },
      {
        title: 'Affiliation',
        path: '/dashboard/affiliate',
      },
    ],
  },
  {
    title: 'Participants',
    icon: 'Users',
    children: [
      {
        title: 'Liste des participants',
        path: '/dashboard/participants',
      },
      {
        title: 'Ajouter un participant',
        path: '/dashboard/ajout_participant',
      },
    ],
  },
  {
    title: 'Widget',
    path: '/dashboard/site_personnel',
    icon: 'AppWindow',
  },
  {
    title: 'Contrôle d\'accès',
    path: '/dashboard/verification',
    icon: 'ScanQrCode',
  },
  {
    title: 'Statistiques',
    path: '/dashboard/statistique',
    icon: 'ChartLine',
  },
  
];

export default navConfig;
